import { useEffect, useState } from "react";
import { companiesCollection, usersCollection } from "../services/firebase";
import useUsers from "../hooks/useUsers";

export const useGetProjectsUsersList = (onSuccess) => {
  const [leadsList, setLeadsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchUsers() {
      try {
        const snapshot = await usersCollection.get();
        const usersData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Filter out inactive and contract users
        const activeAndInactiveUsers = usersData.filter(
          (user) => !["Contract"].includes(user.employmentStatus)
        );

        // Map active users to leads list format
        const leads = activeAndInactiveUsers.map((user) => ({
          id: user.id,
          label: `${user.firstName} ${user.surname}`,
          value: `${user.firstName} ${user.surname}`,
          category: user.serviceGroup,
          employmentStatus: user.employmentStatus,
        }));

        setLeadsList(leads);
        if (onSuccess) onSuccess(leads); // Optional callback
      } catch (err) {
        console.error("Error fetching users:", err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    }

    fetchUsers();
  }, [onSuccess]);

  return { leadsList, isLoading, error };
};

export const useGetClientsList = (onSuccess, { excludeInactive = false } = {}) => {
  useEffect(() => {
    async function fetchClients() {
      try {
        const snapshot = await companiesCollection
          .where("type", "in", ["Client"]) // Fetch only clients
          .get();

        let companies = snapshot.docs.map((doc) => ({
          label: doc.data().companyName,
          value: doc.id, // Assuming you want to use the document ID as the value
          companyState: doc.data().companyState,
        }));

        if (excludeInactive) {
          companies = companies.filter((company) => company.companyState !== "Inactive");
        }

        onSuccess(companies);
      } catch (error) {
        console.error("Error fetching clients:", error);
      }
    }

    fetchClients();
  }, [excludeInactive]);
};
